/**
 * Route: /hotspots — W1.2 / B8.1 / F-033
 *
 * validateSearch mit Zod definiert die erlaubten URL-Search-Params.
 * TanStack Router validiert und coerct automatisch.
 * B8.1: Added device_type, sort, sort_dir parameters.
 * F-033: Added filter parameter for 4-tab layout (My/Affiliated/Inactive/Neighbourhood).
 */
import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { HotspotsList } from '../features/hotspots/HotspotsList'

const hotspotsSearchSchema = z.object({
  // FE-ROB-06: .catch() statt nacktem .optional() — TanStack Router JSON-parst
  // jeden Search-Wert, `?q=123` kommt also als number an und liess z.string()
  // werfen. Ein validateSearch-Throw ersetzt die GESAMTE Seite (inkl. AppShell)
  // durch die Root-Fehlerseite — ein geteilter Link mit numerischer Suche darf
  // die App nicht zerlegen. .catch(undefined) faellt still auf "kein Filter".
  q: z.string().optional().catch(undefined),
  status: z.enum(['all', 'online', 'warn', 'offline']).optional().default('all').catch('all'),
  filter: z.enum(['owned', 'affiliate', 'inactive', 'neighbour']).optional().default('owned').catch('owned'),
  device_type: z.enum(['all', 'iot', 'cbrs', 'wifi']).optional().default('all').catch('all'),
  // Stream H (R4): rank/yesterday/two_days/hnt_7d_avg ergaenzt — die Werte
  // muessen mit SortKey in useHotspots.ts uebereinstimmen, sonst verwirft
  // validateSearch die URL still auf 'name'.
  sort: z
    .enum(['name', 'rank', 'hnt_24h', 'yesterday', 'two_days', 'hnt_7d', 'hnt_30d', 'hnt_7d_avg', 'status'])
    .optional()
    .default('name')
    // FE-ROB-06: alter Bookmark mit entferntem Sort-Wert -> Default statt Crash
    .catch('name'),
  sort_dir: z.enum(['asc', 'desc']).optional().default('asc').catch('asc'),
  page: z.number().int().positive().optional().default(1).catch(1),
})

export const Route = createFileRoute('/_auth/hotspots/')({
  validateSearch: hotspotsSearchSchema,
  component: HotspotsPage,
})

function HotspotsPage() {
  const search = Route.useSearch()

  return (
    <HotspotsList
      filters={{
        q: search.q,
        status: search.status,
        filter: search.filter,
        device_type: search.device_type,
        sort: search.sort,
        sort_dir: search.sort_dir,
        page: search.page,
      }}
    />
  )
}
